var Report = {

  modaltype: false,

  init: function () {
    this.modal();
  },

  modal: function(){
    var _$btn = $('.js-p-repot-modal-btn');
    var _src;
    var _this = this;
    _$btn.on('click',function(){
      _this.modaltype = $(this).data('modaltype');
      _src = $(this).data('src');
      $(_this.setModalTemp(_src)).appendTo('body').fadeIn(200,function(){
        $('body').css({'overflow':'hidden'});
        _this.closeModal();
      });
    });
  },

  setModalTemp: function(_src) {
    var modalTemp;
    if (this.modaltype === 'video') {
      modalTemp = '<div class="c-modal-overlay js-p-repot-modal-close-btn">' +
        '<div class="c-modal-wrapper">' +
          '<div class="c-modal-inner">' +
            '<div class="c-modal-contents">' +
              '<div class="p-report-modal-inner">' +
                '<a href="javascript:void(0)" id="js-p-repot-modal-close-btn" class="js-p-repot-modal-close-btn p-report-modal-close-btn"><img src="/assets/img/common/btn_close.png"></a>' +
                '<div class="c-youtube-holder">' +
                  '<iframe width="420" height="315" src="https://www.youtube.com/embed/'+ _src +'?rel=0" frameborder="0" allowfullscreen></iframe>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    } else if (this.modaltype === 'img') {
      modalTemp = '<div class="c-modal-overlay js-p-repot-modal-close-btn">' +
        '<div class="c-modal-wrapper">' +
          '<div class="c-modal-inner">' +
            '<div class="c-modal-contents">' +
              '<div class="p-report-modal-inner">' +
                '<a href="javascript:void(0)" id="js-p-repot-modal-close-btn" class="js-p-repot-modal-close-btn p-report-modal-close-btn"><img src="/assets/img/common/btn_close.png"></a>' +
                  '<img src="/assets/img/report/vol/01/'+ _src +'.jpg" frameborder="0" allowfullscreen>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    return modalTemp;
  },

  closeModal: function(){
    var _$btn = $('.js-p-repot-modal-close-btn');
    _$btn.on('click',function(){
      $('.c-modal-overlay').fadeOut(200,function(){
        $(this).remove();
        $('body').css({'overflow':'auto'});
      });
    });
  },
};





module.exports = Report;



//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_report.js
// module id = 18
// module chunks = 0